import React from 'react';

const MindMapEdge = ({ sourceNode, targetNode }) => {
  if (!sourceNode || !targetNode) return null;

  // Node center points (assuming node width ~200, height ~40 for collapsed cards)
  const nodeWidth = 200;
  const nodeHeight = 40;
  
  const x1 = sourceNode.x + nodeWidth / 2;
  const y1 = sourceNode.y + nodeHeight / 2;
  const x2 = targetNode.x + nodeWidth / 2;
  const y2 = targetNode.y + nodeHeight / 2;

  // Calculate control points for smooth bezier curve
  const midX = (x1 + x2) / 2;
  const midY = (y1 + y2) / 2;
  
  // Determine curve direction based on relative positions
  const dx = x2 - x1;
  const dy = y2 - y1;
  const distance = Math.sqrt(dx * dx + dy * dy);
  
  // Control point offset (more curve for longer distances)
  const curveStrength = Math.min(distance * 0.3, 100);
  
  // Create smooth S-curve or simple curve based on node positions
  let path;
  if (Math.abs(dx) > Math.abs(dy)) {
    // Horizontal bias - curve vertically
    const cp1x = x1 + dx * 0.25;
    const cp1y = y1;
    const cp2x = x2 - dx * 0.25;
    const cp2y = y2;
    path = `M ${x1} ${y1} C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${x2} ${y2}`;
  } else {
    // Vertical bias - curve horizontally
    const cp1x = x1;
    const cp1y = y1 + dy * 0.25;
    const cp2x = x2;
    const cp2y = y2 - dy * 0.25;
    path = `M ${x1} ${y1} C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${x2} ${y2}`;
  }

  return (
    <g className="mind-map-edge">
      {/* Shadow/glow effect */}
      <path
        d={path}
        fill="none"
        stroke="rgba(255, 255, 255, 0.05)"
        strokeWidth="6"
        strokeLinecap="round"
      />
      {/* Main line */}
      <path
        d={path}
        fill="none"
        stroke="rgba(255, 255, 255, 0.2)"
        strokeWidth="2"
        strokeLinecap="round"
        style={{
          filter: 'drop-shadow(0 0 2px rgba(255, 255, 255, 0.1))',
        }}
      />
      {/* Animated dot (optional) */}
      <circle r="3" fill="rgba(255, 255, 255, 0.4)">
        <animateMotion
          dur="3s"
          repeatCount="indefinite"
          path={path}
        />
      </circle>
    </g>
  );
};

export default MindMapEdge;
